<template lang="pug">
  v-flex(xs12 sm6 md4).card-content
    v-card(:style="{ 'max-height': height ? height + 'px' : 'none' }").addon-card.mb-3
      v-container
        v-layout(row)
          slot(name="icon")
        v-card-title
          v-flex.body
            ul.features(v-if="properties.features")
              li(v-for="item in properties.features")
                span {{ item.text }}
            p(v-else) {{ properties.text }}
      v-flex.actions.text-center
        v-btn.btn-card(
          color='primary'
          @click="manageButtonClick"
        ) {{ properties.textButton }}
</template>
<script>
export default {
  name: 'AddonCard',
  props: {
    properties: Object,
    height: {
      type: String,
      default: "",
    },
  },
  methods: {
    manageButtonClick() {
      this.$emit('buttonAction', this.properties);
    }
  }
};
</script>
<style lang="scss" scoped>
.card-content {
  display: flex;
  flex-flow: row wrap;

  .addon-card {
    width: 98%;
    border-radius: 5px;
    border: 1px solid rgba(204, 204, 204, 0.91);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .container {
    padding: 10px;
    min-height: 60px;
  }

  .v-card__title {
    align-items: flex-end;
    padding-bottom: 5px;
  }

  .title {
    font-weight: bold;
    font-size: 18px;
    line-height: 25px;
    letter-spacing: 0.01em;
    font-size: 18px;
    white-space: pre-wrap;
  }

  .body {
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0.01em;
    white-space: pre-wrap;
  }

  .text-center {
    text-align: center;
  }

  .icon {
    display: flex;
    justify-content: flex-start;
  }

  .title-container {
    flex: 1 1 auto;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
  }

  .features {
    font-size: 12px;
    line-height: 16px;
  }

  .actions {
    width: 100%;
    margin-bottom: 15px;
    display: flex;
    justify-content: center;

    .btn-card {
      text-transform: initial !important;
      font-size: 12px;
      max-width: 100%;
    }
  }
}
</style>
